import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { msalConfig } from "./updatedAuthConfig";
import { MsalProvider } from "@azure/msal-react";
import * as msal from "@azure/msal-browser";
const msalInstance = new msal.PublicClientApplication(msalConfig);

// Use createRoot instead of ReactDOM.render
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
